import type { StatusTone } from '../contracts/common';
import type { TimeEntryBillingState, TimeEntrySource, TimeReportGroup, TimeReportPeriod } from '../contracts/time';

/** Źródło wpisu czasu (lista wpisów, historia). */
export const TIME_ENTRY_SOURCE_LABELS: Record<TimeEntrySource, string> = {
  manual: 'Ręcznie',
  voice: 'Głosem',
  ai: 'Od AI',
  mcp: 'Przez MCP',
};

/** Okresy raportu (Figma 06 Czas / Raport). */
export const TIME_REPORT_PERIOD_LABELS: Record<TimeReportPeriod, string> = {
  this_week: 'Ten tydzień',
  this_month: 'Ten miesiąc',
  last_month: 'Poprzedni miesiąc',
  custom: 'Zakres',
};

/** Grupowanie raportu („Według projektu”). */
export const TIME_REPORT_GROUP_LABELS: Record<TimeReportGroup, string> = {
  project: 'Według projektu',
  client: 'Według klienta',
  user: 'Według osoby',
  day: 'Według dnia',
};

/** Stan wpisu w rozliczeniach (`timeEntryBillingState` z `@fos/shared/contracts/time`). */
export const TIME_ENTRY_BILLING_STATE_LABELS: Record<TimeEntryBillingState, string> = {
  unbilled: 'Niezafakturowany',
  in_draft: 'W zestawieniu',
  locked: 'Rozliczony',
  non_billable: 'Nierozliczany',
};

export const TIME_ENTRY_BILLING_STATE_TONES: Record<TimeEntryBillingState, StatusTone> = {
  unbilled: 'warning',
  in_draft: 'accent',
  locked: 'success',
  non_billable: 'neutral',
};

/** Pola w historii zmian wpisu czasu. */
export const TIME_ENTRY_FIELD_LABELS: Record<string, string> = {
  clientId: 'Klient',
  projectId: 'Projekt',
  serviceId: 'Usługa',
  taskId: 'Zadanie',
  startedAt: 'Początek',
  endedAt: 'Koniec',
  durationSeconds: 'Czas',
  description: 'Opis',
  billable: 'Rozliczany',
  rate: 'Stawka',
  amount: 'Kwota',
  userId: 'Osoba',
};
